import  { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { dodProgramParticipants } from '../../../../../../redux/dod-program-participants/action';
import { useSelector } from 'react-redux';
import { selectDodProgramParticipantsQueryItems } from '../../../../../../redux/dod-program-participants/selector';
import DodProgramParticipantComponent from '../components/shipx-program-participant.component';




const ShipXProgramParticipant = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
    const accountTypeQuery = useSelector(selectDodProgramParticipantsQueryItems)
  const [
    selectedDODProgramParticipant,
    setSelectedDODProgramParticipant
  ] = useState<any>({})


  const fetchChannelProgramById = () => {
    dispatch(dodProgramParticipants.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-shipx-program-participants/fetch-detail`, entity: 'dodProgramParticipants', jsonData: {
        Context:{},
        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDODProgramParticipant({ ...selectedDODProgramParticipant, [field]: event });
  }

  useEffect(
    () => {
    
        if (parmas?.id > 0) {
          fetchChannelProgramById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedDODProgramParticipant(accountTypeQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async () => {
    if (parmas?.id > 0) {
      console.log(selectedDODProgramParticipant,'selectedDODProgramParticipant')
      await dispatch(dodProgramParticipants.resetAction({ actionType: 'update' }))
      await dispatch(dodProgramParticipants.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-shipx-program-participants`, entity: 'accountTypes', jsonData: {

         
              Context:{},
            Records:[
              
                 {
      "Id": selectedDODProgramParticipant?.GlobalShipXProgramParticipantId,
      "Name": selectedDODProgramParticipant?.Name,
      "Code": selectedDODProgramParticipant?.Code,
      "Description": selectedDODProgramParticipant?.Description,
       "IsActive":selectedDODProgramParticipant?.IsActive,
      "CreatedOnUtc":selectedDODProgramParticipant?.CreatedOnUtc,
      "ModifiedOnUtc":selectedDODProgramParticipant?.ModifiedOnUtc
    }
              
            ]

        }
      }))

    } else {
      await dispatch(dodProgramParticipants.resetAction({ actionType: 'create' }))
      await dispatch(dodProgramParticipants.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-shipx-program-participants`, entity: 'accountTypes', jsonData: {

         
              Context:{},
            Records:[selectedDODProgramParticipant]
        }
      }))
    }

    back()
  }

  const back = () => {
    navigate('/dbn/shipx-cloud/channel-management/shipx-program-participants')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <DodProgramParticipantComponent
          selectedDODProgramParticipant={selectedDODProgramParticipant}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
        />
      }
    </>
  )

}

export default ShipXProgramParticipant;